import React from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import { isMobile, isTablet } from '../../../utils/adaptive';
import { CarouselWrapper } from '../styles/carousel.style';

const propTypes = {
  dots: PropTypes.bool,
  numSlides: PropTypes.number,
  tabletSlides: PropTypes.number,
  hideArrows: PropTypes.bool,
  children: PropTypes.array,
  auto: PropTypes.bool,
};

const defaultProps = {
  dots: true,
  numSlides: 3,
  tabletSlides: 3,
  hideArrows: false,
  children: [],
  auto: false,
};

/**
 * Generates a previous arrow
 * @param {object} props Incoming Props
 * @returns {XML} A Previous Arrow
 */
function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      className={className}
      style={{ ...style, display: 'block', background: "url('/images/arrow.svg') no-repeat" }}
      onClick={onClick}
      type="button"
    />
  );
}

/**
 * Generates a next arrow
 * @param {object} props Incoming Props
 * @returns {XML} A next Arrow
 */
function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      className={className}
      style={{
        ...style,
        display: 'block',
        background: "url('/images/arrow.svg') no-repeat",
        transform: 'scaleX(-1)',
      }}
      onClick={onClick}
      type="button"
    />
  );
}

/**
 * Generates a Carousel Component
 */
class Carousel extends React.Component {
  /**
   * Constructor
   * @param {object} props Incoming Props
   */
  constructor(props) {
    super(props);
    this.state = {
      isMobileLocal: false,
      isTabletLocal: false,
    };
  }

  /**
   * Sets the state to mobile if the width is smaller than
   * the mobile breakpoint
   */
  componentDidMount() {
    if (isMobile()) {
      this.setState({ isMobileLocal: true });
    } else if (isTablet()) {
      this.setState({ isTabletLocal: true });
    }
  }

  /**
   * Renders the component
   * @returns {XML} A Carousel
   */
  render() {
    const {
      dots,
      numSlides,
      tabletSlides,
      hideArrows,
      children,
      auto,
      className,
      noInfinite,
      inScrollCount,
      pause,
      beforeChange,
    } = this.props;
    const { isMobileLocal, isTabletLocal } = this.state;
    let slideCount = numSlides;
    let scrollCount = inScrollCount || 3;
    if (isMobileLocal) {
      slideCount = 1;
      scrollCount = 1;
    }
    if (isTabletLocal) {
      slideCount = tabletSlides;
      scrollCount = tabletSlides;
    }
    const settings = {
      dots,
      infinite: !noInfinite,
      autoplay: auto && !pause,
      speed: 1000,
      autoplaySpeed: 10000,
      slidesToShow: slideCount,
      slidesToScroll: scrollCount,
      arrows: !isMobileLocal && !hideArrows,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      className: dots && numSlides > 1 ? 'slick-dotted' : '',
      beforeChange,
    };
    return (
      <CarouselWrapper className={className}>
        <Slider {...settings}>{children}</Slider>
      </CarouselWrapper>
    );
  }
}

Carousel.propTypes = propTypes;
Carousel.defaultProps = defaultProps;

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/carousel/components/carousel.js